import { type Candidate } from "@vidario/domain";
import { Card } from "@vidario/ui";
import { type ReactElement } from "react";

import { useMaskedCandidate } from "../../anonym/useAnonymView";
import { PeriodLabel } from "./PeriodLabel";

/** Education timeline. Populated by the Xing SSR-cache parser and the
 * LinkedIn-enrichment Claude prompt — Finding 5 / 8. Rendered as a
 * compact vertical list, no marker dots, to keep it visually
 * subordinate to the work-history `CareerCard`. */
export function EducationCard({ candidate: raw }: { candidate: Candidate }): ReactElement | null {
  // The Anonym-Ansicht (#140) drops school and description.
  const { candidate } = useMaskedCandidate(raw);
  if (candidate.educationEntries.length === 0) return null;
  return (
    <Card>
      <h3 className="m-0 mb-4 text-[15px] font-semibold">Ausbildung</h3>
      <ul className="m-0 flex list-none flex-col gap-3 p-0">
        {candidate.educationEntries.map((e, i) => {
          const heading = [e.degree, e.fieldOfStudy].filter(Boolean).join(" — ");
          return (
            <li key={`${e.school}-${i}`} className="flex flex-col gap-0.5">
              {/* An open end in education usually means still studying (#157). */}
              <PeriodLabel from={e.startDate} to={e.endDate} openEnd="ongoing" />
              {heading && <span className="text-sm font-semibold">{heading}</span>}
              {e.school && <span className="text-[13px] text-text-secondary">{e.school}</span>}
              {e.description && (
                <span className="mt-1 text-[13px] leading-relaxed text-text-tertiary">
                  {e.description}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </Card>
  );
}
